(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["zen-flow-experience"] && !Shopify.designMode) return;
  try {
    class ZenFlowExperience extends HTMLElement {
  connectedCallback() {
    const id = this.querySelector('[id*="zf-grid-"]').id.replace('zf-grid-', '');
    this._id = id;
    this._code = this.dataset.code || 'MYRITUAL';
    this._discount = this.dataset.discount || '20% de descuento en divain. RITUAL';
    this._revealed = 0;
    this._checkedDays = JSON.parse(localStorage.getItem('zf_tracker_' + id) || '[]');

    this._days = [
      {type:'progreso',icon:'🌱',headline:'Hoy empieza tu ritual.',body:'Tu cuerpo recibe hoy los primeros compuestos activos. La ashwagandha y el triptófano necesitan unos días para acumularse en el organismo — la consistencia es la clave.'},
      {type:'sabias',icon:'🧠',headline:'¿Sabías que la melatonina no te duerme?',body:'No actúa como un sedante. Lo que hace es enviar la señal "es de noche" a tu cerebro. Por eso funciona mejor tomarla 20 minutos antes — le da tiempo a preparar el entorno hormonal para el sueño.'},
      {type:'reto',icon:'📵',headline:'Esta noche: cero pantallas 1 hora antes de dormir.',body:'La luz azul de los dispositivos suprime la producción de melatonina hasta un 50%. Pon el móvil en modo avión o déjalo fuera del dormitorio. DREAMS hará el resto.'},
      {type:'progreso',icon:'🌿',headline:'Día 4: tu sistema nervioso empieza a escuchar.',body:'La ashwagandha trabaja modulando el eje HPA, que regula tu respuesta al estrés. No la sentirás de golpe — la notarás en que reaccionas con más calma a lo que antes te alteraba.'},
      {type:'sabias',icon:'🌿',headline:'¿Sabías que la ashwagandha tiene 3.000 años?',body:'Es uno de los adaptógenos más estudiados de la medicina ayurvédica. Hoy más de 60 estudios clínicos respaldan sus efectos sobre el estrés y la vitalidad.'},
      {type:'reto',icon:'✍️',headline:'Reto: escribe una intención cada mañana durante 7 días.',body:'Toma ADAPT y antes de abrir el móvil, escribe en papel una sola frase: qué quieres sentir hoy. No qué tienes que hacer — cómo quieres sentirte.'},
      {type:'progreso',icon:'💤',headline:'7 días. Puede que ya notes el sueño diferente.',body:'Los estudios con melatonina muestran que los primeros cambios en la facilidad para conciliar el sueño aparecen entre el día 5 y el 10 de uso regular.'},
      {type:'sabias',icon:'🌊',headline:'¿Sabías que el GABA es tu "freno" cerebral?',body:'El GABA es el principal neurotransmisor inhibidor del sistema nervioso central. La pasiflora, la valeriana y el GABA de DREAMS actúan sobre este sistema para favorecer la relajación.'},
      {type:'reto',icon:'🚶',headline:'Reto: 15 minutos de paseo sin móvil, hoy.',body:'El movimiento aumenta la biodisponibilidad de los adaptógenos. Un paseo tranquilo activa el sistema parasimpático y amplifica el efecto de la ashwagandha sobre el cortisol.'},
      {type:'progreso',icon:'🧬',headline:'Día 10: el magnesio empieza a notar diferencia.',body:'El magnesio participa en más de 300 reacciones enzimáticas en el cuerpo, incluyendo la producción de energía celular. Si notas que te cansas menos a media tarde, puede ser una de las primeras señales.'},
      {type:'sabias',icon:'🌺',headline:'¿Sabías que la bacopa lleva 40 días trabajando?',body:'La Bacopa monnieri tiene respaldo clínico sólido para la memoria — pero sus efectos completos se observan a las 4-6 semanas de uso continuado. Estás poniendo las bases ahora mismo.'},
      {type:'reto',icon:'⏰',headline:'Reto: establece una hora fija para DREAMS esta semana.',body:'La melatonina funciona mejor cuando el organismo la espera. Tómala cada noche a la misma hora durante 7 días — tu ritmo circadiano empezará a anticiparla.'},
      {type:'progreso',icon:'⚡',headline:'Día 13: energía sin picos, sin bajadas.',body:'Las vitaminas B actúan como cofactores en la producción de ATP. A diferencia de la cafeína, su efecto es gradual y sostenido. Si notas que tu energía del mediodía es más estable, es exactamente lo que se espera.'},
      {type:'sabias',icon:'💙',headline:'¿Sabías que el triptófano es el precursor de tu bienestar?',body:'El L-triptófano es el aminoácido del que tu cuerpo fabrica serotonina y, a partir de ella, melatonina. ADAPT y DREAMS trabajan juntos en esta cadena.'},
      {type:'reto',icon:'🧘',headline:'Reto: respiración 4-7-8 antes de DREAMS.',body:'Inhala 4 segundos. Aguanta 7. Exhala 8. Repite 3 veces justo después de tomar DREAMS — activa el sistema parasimpático y prepara el cuerpo para dormir.'},
      {type:'progreso',icon:'🌙',headline:'Mitad del camino. ¿Cómo duermes ahora vs. el día 1?',body:'Los cambios en el sueño son graduales: primero te cuesta menos quedarte dormida, luego el sueño se vuelve más profundo, y finalmente empiezas a despertarte más descansada. ¿En qué etapa estás?'},
      {type:'sabias',icon:'🌿',headline:'¿Sabías que la pasiflora tiene historia?',body:'Los pueblos indígenas de América del Norte la usaban como sedante natural siglos antes de que la ciencia confirmara su mecanismo. Actúa aumentando los niveles de GABA sin producir dependencia.'},
      {type:'reto',icon:'🌡️',headline:'Reto: dormitorio fresco esta noche.',body:'La temperatura ideal para dormir está entre 16 y 19ºC. Un dormitorio demasiado caliente impide alcanzar las fases de sueño profundo. Esta noche, baja la calefacción o abre la ventana antes de acostarte.'},
      {type:'progreso',icon:'🧠',headline:'Día 19: la bacopa ya lleva semanas trabajando.',body:'Estás cerca del umbral de 4 semanas donde los estudios empiezan a medir sus efectos sobre la memoria de trabajo. Puede que notes que retienes mejor lo que lees, o que encuentras las palabras con más facilidad.'},
      {type:'sabias',icon:'🦠',headline:'¿Sabías que el estrés crónico eleva el cortisol?',body:'El cortisol elevado interfiere con el sueño, la memoria y el sistema inmune. La ashwagandha ha demostrado en estudios clínicos reducir los niveles de cortisol sérico en un 15-30% tras 8 semanas de uso.'},
      {type:'reto',icon:'☀️',headline:'Reto: luz natural en los primeros 30 min del día.',body:'Salir a la luz del sol en los primeros 30 minutos del despertar activa el reloj circadiano y potencia la producción de serotonina durante el día — la misma que se convierte en melatonina por la noche.'},
      {type:'progreso',icon:'💆',headline:'Día 21: tres semanas. El eje del estrés se regula.',body:'A las tres semanas, los estudios sobre ashwagandha muestran reducciones significativas en la percepción subjetiva del estrés. No es que los problemas desaparezcan — es que tu sistema nervioso tiene más recursos para gestionarlos.'},
      {type:'sabias',icon:'🌙',headline:'¿Sabías que la valeriana actúa diferente al GABA?',body:'La valeriana inhibe la enzima que destruye el GABA natural del cerebro. El resultado es más GABA disponible y más relajación — pero el mecanismo es más suave y no produce tolerancia.'},
      {type:'reto',icon:'📖',headline:'Reto: leer en papel 20 minutos antes de dormir.',body:'Sustituye los 20 minutos de móvil antes de dormir por un libro en papel. La estimulación de la pantalla mantiene activo el córtex prefrontal. Un libro lo desactiva. DREAMS hace el resto.'},
      {type:'progreso',icon:'🌟',headline:'Día 24: tu foco mental en su punto más alto.',body:'Si llevas tomando MIND con regularidad, estás cerca del momento donde la bacopa muestra sus mejores resultados. Los estudios hablan de mejoras en memoria a largo plazo, tiempo de reacción y reducción del olvido.'},
      {type:'sabias',icon:'⚗️',headline:'¿Sabías que el hierro es esencial para pensar?',body:'El hierro de MIND es cofactor esencial para la síntesis de dopamina y serotonina, y participa en la mielinización — el "aislante" que hace que los impulsos nerviosos viajen más rápido.'},
      {type:'reto',icon:'🧊',headline:'Reto: agua fría en la cara al despertar.',body:'Salpicarte la cara con agua fría al levantarte activa el reflejo de buceo, estimula el nervio vago y activa el sistema parasimpático. Es un reset instantáneo del sistema nervioso que amplifica el efecto de ADAPT.'},
      {type:'progreso',icon:'🔄',headline:'Día 27: tu cuerpo ha aprendido el ritmo.',body:'Después de casi cuatro semanas, tu sistema circadiano ha interiorizado el ritual. La melatonina se produce con más facilidad porque tu cuerpo ya anticipa la señal. Eso es equilibrio real.'},
      {type:'sabias',icon:'🌱',headline:'¿Sabías que los adaptógenos son "inteligentes"?',body:'A diferencia de los estimulantes o sedantes, los adaptógenos como la ashwagandha regulan en la dirección que el cuerpo necesita. Si estás excitada, te calman. Si estás agotada, te activan.'},
      {type:'reto',icon:'🤫',headline:'Reto: 5 minutos de silencio consciente hoy.',body:'Sin música, sin podcast, sin pantallas. Solo 5 minutos de silencio — activa las ondas cerebrales alfa, asociadas a la creatividad y la calma. Es el complemento perfecto para MIND.'},
      {type:'progreso',icon:'🏆',headline:'30 días. Lo has conseguido.',body:'Has completado tu primer protocolo divain. ZEN FLOW. Tu sistema nervioso es más resiliente, tu sueño más reparador, tu foco más sostenido. Estos no son efectos temporales — son cambios que has construido con consistencia.'}
    ];

    this._initOverlays();
    this._initTracker();
    this._initModals();
  }

  _initOverlays() {
    const id = this._id;
    ['adapt','mind','dreams'].forEach((card, i) => {
      const overlay = this.querySelector(`#zf-overlay-${card}-${id}`);
      if (!overlay) return;
      overlay.addEventListener('click', () => {
        if (overlay.classList.contains('hidden')) return;
        overlay.classList.add('hidden');
        overlay.setAttribute('aria-expanded', 'true');
        overlay.closest('.zf-card').classList.add('revealed');
        overlay.closest('.zf-card').querySelector('.zf-card-content').removeAttribute('aria-hidden');
        this._revealed++;
        this._updateProgress();
        if (this._revealed === 3) {
          setTimeout(() => {
            const cel = this.querySelector(`#zf-celebration-${id}`);
            cel.removeAttribute('hidden');
            cel.querySelector(`#zf-cel-btn-${id}`).focus();
          }, 600);
        }
      });
    });
  }

  _updateProgress() {
    const id = this._id;
    const fill = this.querySelector(`#zf-fill-${id}`);
    const count = this.querySelector(`#zf-count-${id}`);
    const region = this.querySelector(`#zf-progress-region-${id}`);
    if (fill) fill.style.inlineSize = (this._revealed / 3 * 100) + '%';
    if (count) count.textContent = this._revealed + '/3';
    if (region) region.setAttribute('aria-valuenow', this._revealed);
  }

  _initTracker() {
    const id = this._id;
    const grid = this.querySelector(`#zf-grid-${id}`);
    if (!grid) return;
    const types = {progreso:'t-progreso', sabias:'t-sabias', reto:'t-reto'};
    for (let i = 0; i < 30; i++) {
      const btn = document.createElement('button');
      const type = this._days[i].type;
      btn.type = 'button';
      btn.className = 'zf-day-btn ' + types[type] + (this._checkedDays.includes(i+1) ? ' checked' : '');
      btn.setAttribute('aria-label', 'Día ' + (i+1) + (this._checkedDays.includes(i+1) ? ' — completado' : ''));
      btn.setAttribute('aria-pressed', this._checkedDays.includes(i+1) ? 'true' : 'false');
      btn.innerHTML = this._checkedDays.includes(i+1) ? '✓' : '<span aria-hidden="true">' + (i+1) + '</span><span class="zf-day-dot" aria-hidden="true"></span>';
      btn.addEventListener('click', () => this._handleDayTap(i+1, btn, i));
      grid.appendChild(btn);
    }
    this._updateStreak();
  }

  _handleDayTap(n, btn, idx) {
    if (this._checkedDays.includes(n)) {
      this._checkedDays = this._checkedDays.filter(d => d !== n);
      btn.classList.remove('checked');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Día ' + n);
      btn.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="zf-day-dot" aria-hidden="true"></span>';
    } else {
      this._checkedDays.push(n);
      btn.classList.add('checked');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', 'Día ' + n + ' — completado');
      btn.textContent = '✓';
      this._openDayModal(idx);
    }
    localStorage.setItem('zf_tracker_' + this._id, JSON.stringify(this._checkedDays));
    this._updateStreak();
  }

  _openDayModal(idx) {
    const id = this._id;
    const d = this._days[idx];
    const modal = this.querySelector(`#zf-day-modal-${id}`);
    const labels = { progreso: d.icon + ' Tu progreso — Día '+(idx+1), sabias: d.icon + ' ¿Sabías que?', reto: d.icon + ' Reto del día' };
    this.querySelector(`#zf-modal-badge-${id}`).className = 'zf-modal-badge ' + d.type;
    this.querySelector(`#zf-modal-badge-${id}`).textContent = labels[d.type];
    this.querySelector(`#zf-modal-day-label-${id}`).textContent = 'Día ' + (idx+1) + ' de 30';
    this.querySelector(`#zf-modal-headline-${id}`).textContent = d.headline;
    this.querySelector(`#zf-modal-body-${id}`).textContent = d.body;
    modal.removeAttribute('hidden');
    this.querySelector(`#zf-modal-close-${id}`).focus();
    this._showTodayBanner(idx);
  }

  _showTodayBanner(idx) {
    const id = this._id;
    const d = this._days[idx];
    const banner = this.querySelector(`#zf-today-${id}`);
    const badge = this.querySelector(`#zf-today-badge-${id}`);
    const labels = { progreso: '🌱 Tu progreso', sabias: '💡 ¿Sabías que?', reto: '🎯 Reto del día' };
    badge.className = 'zf-today-badge ' + d.type;
    badge.textContent = labels[d.type];
    this.querySelector(`#zf-today-day-${id}`).textContent = 'Día ' + (idx+1) + ' de 30';
    this.querySelector(`#zf-today-content-${id}`).innerHTML = '<strong>' + d.headline + '</strong> ' + d.body;
    banner.removeAttribute('hidden');
  }

  _updateStreak() {
    const sorted = [...this._checkedDays].sort((a,b) => a-b);
    let streak = 0;
    for (let i = 1; i <= 30; i++) {
      if (sorted.includes(i)) streak++;
      else if (streak > 0) break;
    }
    const el = this.querySelector(`#zf-streak-${this._id}`);
    if (el) el.textContent = streak;
    if (sorted.length > 0) this._showTodayBanner(sorted[sorted.length-1]-1);
    if (streak === 30) {
      setTimeout(() => {
        const reward = this.querySelector(`#zf-reward-${this._id}`);
        reward.removeAttribute('hidden');
        reward.querySelector('.zf-reward-close').focus();
      }, 800);
    }
  }

  _initModals() {
    const id = this._id;
    // Day modal close
    const dayModalClose = this.querySelector(`#zf-modal-close-${id}`);
    if (dayModalClose) dayModalClose.addEventListener('click', () => {
      this.querySelector(`#zf-day-modal-${id}`).setAttribute('hidden', '');
    });
    // Celebration close → scroll to timeline
    const celBtn = this.querySelector(`#zf-cel-btn-${id}`);
    if (celBtn) celBtn.addEventListener('click', () => {
      this.querySelector(`#zf-celebration-${id}`).setAttribute('hidden', '');
      const timeline = this.querySelector('.zf-timeline');
      if (timeline) setTimeout(() => timeline.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    });
    // Reward close
    const rewardClose = this.querySelector(`#zf-reward-close-${id}`);
    if (rewardClose) rewardClose.addEventListener('click', () => {
      this.querySelector(`#zf-reward-${id}`).setAttribute('hidden', '');
    });
    // Copy code
    const codeBlock = this.querySelector(`#zf-code-block-${id}`);
    if (codeBlock) codeBlock.addEventListener('click', () => {
      navigator.clipboard.writeText(this._code).catch(() => {});
      codeBlock.classList.add('copied');
    });
    // Close modals on backdrop click
    this.querySelector(`#zf-day-modal-${id}`)?.addEventListener('click', e => {
      if (e.target === e.currentTarget) e.currentTarget.setAttribute('hidden','');
    });
    this.querySelector(`#zf-reward-${id}`)?.addEventListener('click', e => {
      if (e.target === e.currentTarget) e.currentTarget.setAttribute('hidden','');
    });
  }
}
if (!customElements.get('zen-flow-experience')) {
  customElements.define('zen-flow-experience', ZenFlowExperience);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["zen-woman-experience"] && !Shopify.designMode) return;
  try {
    class ZenWomanExperience extends HTMLElement {
  connectedCallback() {
    this._blockId = this.querySelector('[data-game="grid"]').id.replace('zw-grid-', '');
    this._code = this.dataset.code || 'MYBALANCE';
    this._discount = this.dataset.discount || '20% de descuento en toda la gama divain. RITUAL';

    this._answers = [null, null, null, null];
    this._currentQ = 0;
    this._gameInited = false;
    this._mgMatched = 0;
    this._mgFlipped = [];
    this._mgProcessing = false;

    this._ingredients = [
      { id: 1, img: 'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/salvia.webp?v=1783425244',      name: 'Salvia',        benefit: 'Contribuye al bienestar durante la menopausia y ayuda a reducir los sudores nocturnos. Actúa mejor tomándola de forma regular, mañana y noche.' },
      { id: 2, img: 'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/schisandra.webp?v=1783425245', name: 'Schisandra',    benefit: 'Ayuda al organismo a adaptarse al estrés. Es uno de los adaptógenos más valorados de la medicina tradicional china, con más de 2.000 años de uso.' },
      { id: 3, img: 'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/yam.webp?v=1783425245',        name: 'Yam Silvestre', benefit: 'Ayuda a gestionar los sofocos, la sudoración y la irritabilidad. Su raíz contiene diosgenina, un fitoestrógeno natural de origen vegetal.' },
      { id: 4, img: 'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/tulsi.webp?v=1783425244',      name: 'Tulsi',         benefit: 'Conocida como la "reina de las hierbas" en la tradición ayurvédica. Apoya el equilibrio emocional y la vitalidad diaria en momentos de cambio hormonal.' },
      { id: 5, img: 'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/probiotic.webp?v=1783425244',  name: 'Probiótico',    benefit: '12.000 millones de microorganismos por cápsula con 3 cepas distintas. En la menopausia el intestino cambia — una microbiota equilibrada impacta en el estado de ánimo y la inmunidad.' },
      { id: 6, img: 'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/vitamin-c.webp?v=1783425244',  name: 'Vitamina C',    benefit: 'Contribuye al funcionamiento normal del sistema inmunitario y a la formación de colágeno. Un antioxidante esencial en esta etapa vital.' }
    ];

    this._productImages = [
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/BALANCE.svg',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/MOOD.svg',
      'https://cdn.shopify.com/s/files/1/0037/1556/3635/files/FLORA.svg'
    ];

    this._bindEvents();
  }

  /* Watch data-code / data-discount for Theme Editor live updates */
  static get observedAttributes() { return ['data-code', 'data-discount']; }

  attributeChangedCallback(name, oldVal, newVal) {
    if (newVal === oldVal) return;
    if (name === 'data-code') {
      this._code = newVal || 'MYBALANCE';
      const el = this.querySelector('[data-modal="reward-code"]');
      if (el) el.textContent = this._code;
    }
    if (name === 'data-discount') {
      this._discount = newVal;
      const strong = this.querySelector('[data-modal="reward-discount"] strong');
      if (strong) strong.textContent = this._discount;
      const teaserStrong = this.querySelector('[data-protocol="teaser-discount"]');
      if (teaserStrong) teaserStrong.textContent = this._discount;
    }
  }

  /* ── HELPERS ── */
  _q(sel) { return this.querySelector(sel); }
  _qq(sel) { return this.querySelectorAll(sel); }

  _showScreen(name) {
    this._qq('.zw-screen').forEach(s => s.classList.remove('zw-screen--active'));
    const target = this._q('[data-screen="' + name + '"]');
    if (target) target.classList.add('zw-screen--active');
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── EVENTS ── */
  _bindEvents() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      const action = btn.dataset.action;

      if (action === 'start-quiz')            { this._showScreen('quiz'); }
      else if (action === 'next-q')           { this._nextQ(parseInt(btn.dataset.from, 10)); }
      else if (action === 'go-to-q')          { this._goToQ(parseInt(btn.dataset.target, 10)); }
      else if (action === 'prev-q')           { if (this._currentQ > 0) this._goToQ(this._currentQ - 1); }
      else if (action === 'show-results')     { this._showResults(); }
      else if (action === 'start-game')       { this._showScreen('game'); this._initMemoryGame(); }
      else if (action === 'back-to-results')  { this._showScreen('results'); }
      else if (action === 'retake-quiz')      { this._retakeQuiz(); }
      else if (action === 'close-ingredient-modal') { this._closeIngredientModal(); }
      else if (action === 'copy-reward-code') { this._copyCode(btn); }
      else if (action === 'close-reward')     { this._q('.zw-reward-modal').hidden = true; }
    });

    /* Option buttons: select answer */
    this._qq('.zw-option').forEach(btn => {
      btn.addEventListener('click', () => {
        const qIdx = parseInt(btn.dataset.q, 10);
        const opt  = parseInt(btn.dataset.opt, 10);
        this._selectOption(qIdx, opt, btn);
      });
    });
  }

  /* ── QUIZ LOGIC ── */
  _selectOption(qIdx, opt, btn) {
    this._qq('[data-q="' + qIdx + '"].zw-option').forEach(b => {
      b.classList.remove('zw-option--selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('zw-option--selected');
    btn.setAttribute('aria-pressed', 'true');
    this._answers[qIdx] = opt;

    /* Enable next button for this question */
    const next = this._q('[data-action="next-q"][data-from="' + qIdx + '"], [data-action="show-results"][data-from="' + qIdx + '"]');
    if (next) { next.disabled = false; next.removeAttribute('aria-disabled'); }
  }

  _goToQ(n) {
    this._qq('.zw-question').forEach(q => q.classList.remove('zw-question--show'));
    const target = this._q('[data-q="' + n + '"].zw-question');
    if (target) target.classList.add('zw-question--show');

    this._qq('[data-dot]').forEach(dot => {
      const i = parseInt(dot.dataset.dot, 10);
      dot.className = 'zw-q-dot';
      if (i < n) dot.classList.add('zw-q-dot--done');
      else if (i === n) dot.classList.add('zw-q-dot--active');
    });

    const progressbar = this._q('[role="progressbar"]');
    if (progressbar) progressbar.setAttribute('aria-valuenow', n + 1);

    this._currentQ = n;
  }

  _nextQ(current) {
    if (this._answers[current] === null) return;
    this._goToQ(current + 1);
  }

  _showResults() {
    if (this._answers[3] === null) return;
    this._showScreen('loading');
    setTimeout(() => {
      this._buildResults();
      this._showScreen('results');
    }, 2200);
  }

  _buildResults() {
    const sym  = this._answers[0];
    const goal = this._answers[3];

    let title, profile, intro, balancePriority, moodPriority;

    if (sym === 0 || goal === 2) {
      title           = 'Tu protocolo: Confort Térmico';
      profile         = 'Balance · Confort físico';
      intro           = 'Tus respuestas muestran que los sofocos y el calor son lo que más impacta en tu día a día. BALANCE es tu aliado principal.';
      balancePriority = '★★ Prioridad máxima — empieza aquí';
      moodPriority    = '2.º producto a incorporar';
    } else if (sym === 1 || goal === 0) {
      title           = 'Tu protocolo: Equilibrio Emocional';
      profile         = 'Mood · Calma interior';
      intro           = 'El equilibrio emocional es tu prioridad. MOOD y BALANCE trabajan juntos para acompañarte en los altibajos de esta etapa.';
      balancePriority = '★ Prioritario — actúa sobre la base hormonal';
      moodPriority    = '★★ Prioridad máxima — empieza aquí';
    } else if (sym === 2 || goal === 1) {
      title           = 'Tu protocolo: Vitalidad y Energía';
      profile         = 'Mood · Vitalidad';
      intro           = 'El cansancio y la falta de energía son muy comunes en esta etapa. Las vitaminas B de MOOD y los probióticos de FLORA son clave para recuperarte.';
      balancePriority = 'Actúa sobre el equilibrio hormonal de base';
      moodPriority    = '★★ Prioridad máxima — vitaminas del grupo B';
    } else {
      title           = 'Tu protocolo: Bienestar Digestivo';
      profile         = 'Flora · Microbiota';
      intro           = 'La salud digestiva es el centro de tu bienestar ahora mismo. FLORA es tu producto estrella, y la microbiota sana influye en todo lo demás.';
      balancePriority = 'Complemento hormonal para el equilibrio global';
      moodPriority    = 'Apoya el estado de ánimo y el sistema nervioso';
    }

    const set = (sel, val) => { const el = this._q(sel); if (el) el.textContent = val; };
    set('[data-result="title"]',          title);
    set('[data-result="profile"]',        profile);
    set('[data-result="intro"]',          intro);
    set('[data-pc="balance-priority"]',   balancePriority);
    set('[data-pc="mood-priority"]',      moodPriority);
  }

  _retakeQuiz() {
    this._answers = [null, null, null, null];
    this._qq('.zw-option').forEach(b => {
      b.classList.remove('zw-option--selected');
      b.removeAttribute('aria-pressed');
    });
    this._qq('[data-action="next-q"], [data-action="show-results"]').forEach(b => {
      b.disabled = true;
      b.setAttribute('aria-disabled', 'true');
    });
    this._goToQ(0);
    this._showScreen('quiz');
  }

  /* ── MEMORY GAME ── */
  _initMemoryGame() {
    if (this._gameInited) return;
    this._gameInited = true;
    this._mgMatched = 0; this._mgFlipped = []; this._mgProcessing = false;

    /* Dots */
    const dotsEl = this._q('[data-game="dots"]');
    dotsEl.innerHTML = '';
    for (let i = 0; i < 6; i++) {
      const d = document.createElement('div');
      d.className = 'zw-mg-dot';
      d.dataset.dotIdx = i;
      dotsEl.appendChild(d);
    }
    dotsEl.setAttribute('aria-valuenow', '0');

    /* Shuffle 12 cards */
    const cards = [...this._ingredients, ...this._ingredients];
    for (let i = cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }

    const grid = this._q('[data-game="grid"]');
    grid.innerHTML = '';
    cards.forEach(ing => {
      const el = document.createElement('div');
      el.className = 'zw-mg-card';
      el.setAttribute('role', 'button');
      el.setAttribute('aria-label', 'Carta boca abajo');
      el.dataset.ingId = ing.id;
      el.innerHTML =
        '<div class="zw-mg-inner">' +
          '<div class="zw-mg-face zw-mg-back-face" aria-hidden="true">' +
            '<div class="zw-mg-back-icon">🌸</div>' +
            '<div class="zw-mg-back-brand">zen</div>' +
          '</div>' +
          '<div class="zw-mg-face zw-mg-front-face" aria-hidden="true">' +
            '<div class="zw-mg-ingredient-display">' +
              '<img class="zw-mg-front-img" src="' + ing.img + '" alt="" width="160" height="240" loading="lazy">' +
              '<div class="zw-mg-front-name-pill">' + ing.name + '</div>' +
            '</div>' +
            '<div class="zw-mg-matched-display">' +
              '<img class="zw-mg-product-img" src="" alt="" width="160" height="240" loading="lazy">' +
              '<div class="zw-mg-match-check" aria-hidden="true">✓</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      el.addEventListener('click', () => this._mgFlipCard(el));
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this._mgFlipCard(el); } });
      el.setAttribute('tabindex', '0');
      grid.appendChild(el);
    });
  }

  _mgFlipCard(el) {
    if (this._mgProcessing) return;
    if (el.classList.contains('zw-mg-card--flipped') || el.classList.contains('zw-mg-card--matched')) return;
    if (this._mgFlipped.length === 2) return;

    el.classList.add('zw-mg-card--flipped');
    el.setAttribute('aria-label', el.querySelector('.zw-mg-front-name-pill').textContent);
    this._mgFlipped.push(el);

    if (this._mgFlipped.length === 2) {
      this._mgProcessing = true;
      const [a, b] = this._mgFlipped;

      if (a.dataset.ingId === b.dataset.ingId) {
        /* Match */
        setTimeout(() => {
          const productImg = this._productImages[Math.floor(Math.random() * this._productImages.length)];
          [a, b].forEach(card => {
            card.querySelector('.zw-mg-product-img').src = productImg;
            card.classList.add('zw-mg-card--matched');
            card.classList.remove('zw-mg-card--flipped');
          });
          this._mgFlipped = [];
          this._mgMatched++;
          this._mgProcessing = false;

          /* Update dot */
          const dot = this._q('[data-dot-idx="' + (this._mgMatched - 1) + '"]');
          if (dot) dot.classList.add('zw-mg-dot--found');
          const dotsEl = this._q('[data-game="dots"]');
          if (dotsEl) dotsEl.setAttribute('aria-valuenow', this._mgMatched);

          const ing = this._ingredients.find(i => i.id == a.dataset.ingId);
          setTimeout(() => this._showIngredientModal(ing), 300);
        }, 400);
      } else {
        /* No match */
        setTimeout(() => {
          a.classList.remove('zw-mg-card--flipped'); b.classList.remove('zw-mg-card--flipped');
          a.setAttribute('aria-label', 'Carta boca abajo');
          b.setAttribute('aria-label', 'Carta boca abajo');
          this._mgFlipped = [];
          this._mgProcessing = false;
        }, 900);
      }
    }
  }

  _showIngredientModal(ing) {
    const modal = this._q('.zw-ingredient-modal');
    this._q('[data-modal="im-emoji"]').innerHTML = '<img src="' + ing.img + '" alt="' + ing.name + '" width="44" height="44" style="object-fit:contain;">';
    this._q('[data-modal="im-name"]').textContent  = ing.name;
    this._q('[data-modal="im-benefit"]').textContent = ing.benefit;
    const left = 6 - this._mgMatched;
    const pairsEl = this._q('[data-modal="im-pairs-left"]');
    pairsEl.innerHTML = left > 0
      ? 'Quedan <strong>' + left + ' par' + (left > 1 ? 'es' : '') + '</strong> por descubrir'
      : '¡Has encontrado todos los pares! 🎉';
    modal.hidden = false;
    this._q('.zw-im-btn').focus();
  }

  _closeIngredientModal() {
    this._q('.zw-ingredient-modal').hidden = true;
    if (this._mgMatched === 6) {
      setTimeout(() => {
        const rewardModal = this._q('.zw-reward-modal');
        rewardModal.hidden = false;
        rewardModal.querySelector('[data-action="close-reward"]').focus();
      }, 500);
    }
  }

  _copyCode(btn) {
    const code = (this._q('[data-modal="reward-code"]') || {}).textContent || this._code;
    navigator.clipboard.writeText(code).catch(() => {
      /* Clipboard unavailable — silent fallback */
    });
    btn.classList.add('zw-reward-code-block--copied');
  }
}

if (!customElements.get('zen-woman-experience')) {
  customElements.define('zen-woman-experience', ZenWomanExperience);
}
  } catch(e) { console.error(e); }
})();

})();
